/**
 * seo/applyMeta.js — Bar Experts
 * Atualiza título, descrição, Open Graph, Twitter e canonical ao trocar de página.
 * (O Google roda JavaScript e lê isto; para redes sociais o build gera HTML por página.)
 */
import { SITE_URL, pageMeta } from './pages'

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', rel)
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

export function applyPageMeta(route) {
  const meta = pageMeta(route.path, route.meta?.title)
  const url = SITE_URL + (meta.path === '/' ? '/' : meta.path)
  const image = SITE_URL + meta.image

  document.title = meta.title
  setMeta('name', 'description', meta.description)
  setMeta('property', 'og:title', meta.title)
  setMeta('property', 'og:description', meta.description)
  setMeta('property', 'og:url', url)
  setMeta('property', 'og:image', image)
  setMeta('property', 'og:image:secure_url', image)
  setMeta('name', 'twitter:title', meta.title)
  setMeta('name', 'twitter:description', meta.description)
  setMeta('name', 'twitter:url', url)
  setMeta('property', 'twitter:image', image)
  setMeta('name', 'robots', meta.noindex || route.meta?.requiresAuth || route.meta?.requiresLevel != null
    ? 'noindex, nofollow'
    : 'index, follow')
  setLink('canonical', url)
}
